/**
 * 팝업 레지스트리
 * 팝업 타입과 컴포넌트를 매핑하는 중앙 관리 시스템
 * 새로운 팝업을 추가할 때는 여기에만 등록하면 됩니다.
 */

import TextPopup from '../../sites/default/pages/popup/TextPopup';
import TextareaPopup from '../../sites/default/pages/popup/TextareaPopup';
import ThumbnailPopup from '../../sites/default/pages/popup/ThumbnailPopup';
import Thumbnail2Popup from '../../sites/default/pages/popup/Thumbnail2Popup';
import SignaturePopup from '../../sites/default/pages/popup/SignaturePopup';
import StampPopup from '../../sites/default/pages/popup/StampPopup';
import ProgramFormPopup from '../../sites/default/pages/popup/ProgramFormPopup';
import ProgramSelectPopup from '../../sites/default/pages/popup/ProgramSelectPopup';
import PdfViewerPopup from '../../sites/default/pages/popup/PdfViewerPopup';
import PreviewPopup from '../../sites/default/pages/popup/PreviewPopup';
import ExpertOrgSelectPopup from '../../sites/default/pages/popup/ExpertOrgSelectPopup';
import TechDemandApplicantsPopup from '../../sites/default/pages/popup/TechDemandApplicantsPopup';
import DeptAgencySelectPopup from '../../sites/default/pages/popup/DeptAgencySelectPopup';
import ConsortiumSelectPopup from '../../sites/default/pages/popup/ConsortiumSelectPopup';
import OrgManagerFormPopup from '../../sites/default/pages/popup/OrgManagerFormPopup';
import CategoryTreeManagePopup from '../../sites/default/pages/popup/CategoryTreeManagePopup';
import CalendarEventFormPopup from '../../sites/default/pages/popup/CalendarEventFormPopup';
import MemberRoleChangePopup from '../../sites/default/pages/popup/MemberRoleChangePopup';
import ConsortiumMemberEditPopup from '../../sites/default/pages/popup/ConsortiumMemberEditPopup';
import ConsortiumRoleManagePopup from '../../sites/default/pages/popup/ConsortiumRoleManagePopup';
import MemberTempPermissionPopup from '../../sites/default/pages/popup/MemberTempPermissionPopup';
import MemberRemovePopup from '../../sites/default/pages/popup/MemberRemovePopup';
import AllianceSpaceInviteProposalPopup from '../../sites/default/pages/popup/AllianceSpaceInviteProposalPopup';
import LegalTermsViewerPopup from '../../sites/default/pages/popup/LegalTermsViewerPopup';
import ForgotPasswordPopup from '../../sites/default/pages/popup/ForgotPasswordPopup';
import InviteCodeHistoryDetailPopup from '../../sites/default/pages/popup/InviteCodeHistoryDetailPopup';
import AccountWithdrawPopup from '../../sites/default/pages/popup/AccountWithdrawPopup';
import SmtpSettingsFormPopup from '../../sites/default/pages/popup/SmtpSettingsFormPopup';

/**
 * 팝업 타입과 컴포넌트 매핑
 * @type {Object.<string, React.ComponentType>}
 */
const popupRegistry = {
  text: TextPopup,
  textarea: TextareaPopup,
  thumbnail: ThumbnailPopup,
  thumbnail2: Thumbnail2Popup,
  signature: SignaturePopup,
  stamp: StampPopup,
  programForm: ProgramFormPopup,
  programSelect: ProgramSelectPopup,
  pdfViewer: PdfViewerPopup,
  formPreview: PreviewPopup,
  expertOrgSelect: ExpertOrgSelectPopup,
  techDemandApplicants: TechDemandApplicantsPopup,
  deptAgencySelect: DeptAgencySelectPopup,
  consortiumSelect: ConsortiumSelectPopup,
  orgManagerForm: OrgManagerFormPopup,
  categoryTreeManage: CategoryTreeManagePopup,
  calendarEventForm: CalendarEventFormPopup,
  memberRoleChange: MemberRoleChangePopup,
  consortiumMemberEdit: ConsortiumMemberEditPopup,
  consortiumRoleManage: ConsortiumRoleManagePopup,
  memberTempPermission: MemberTempPermissionPopup,
  memberRemove: MemberRemovePopup,
  allianceSpaceInviteProposal: AllianceSpaceInviteProposalPopup,
  legalTermsViewer: LegalTermsViewerPopup,
  forgotPassword: ForgotPasswordPopup,
  inviteCodeHistoryDetail: InviteCodeHistoryDetailPopup,
  accountWithdraw: AccountWithdrawPopup,
  smtpSettingsForm: SmtpSettingsFormPopup,
};

/**
 * 팝업 타입에 해당하는 컴포넌트를 반환
 * @param {string} type - 팝업 타입
 * @returns {React.ComponentType|null} 팝업 컴포넌트 또는 null
 */
export const getPopupComponent = (type) => {
  return popupRegistry[type] || null;
};

/**
 * 새로운 팝업 타입을 레지스트리에 등록
 * @param {string} type - 팝업 타입
 * @param {React.ComponentType} component - 팝업 컴포넌트
 */
export const registerPopup = (type, component) => {
  if (popupRegistry[type]) {
    console.warn(`[PopupRegistry] 팝업 타입 '${type}'가 이미 등록되어 있습니다. 덮어씁니다.`);
  }
  popupRegistry[type] = component;
};

/**
 * 등록된 모든 팝업 타입 목록 반환
 * @returns {string[]} 팝업 타입 배열
 */
export const getRegisteredTypes = () => {
  return Object.keys(popupRegistry);
};

export default popupRegistry;
